// ADR 1.10.26c §5 — which plan the upgrade page opens on.
//
// Mirrors Android's paywall default (`SubscriptionViewModel.kt:70,101-104`).
// Web-local on purpose: Android's copy is two lines in a view-model, and moving
// it to `rust-core` would shift UniFFI checksums for no shared behaviour.

import type { Plan } from '../../api/subscriptions'

/** The plan the trial mails link to, and the default when the link names none. */
const DEFAULT_PLAN_ID = 'plus_annual'

/** Where an upgrade door sends a learner: the plan picker, opened on Plus annual. */
export const UPGRADE_PATH = `/upgrade?plan=${DEFAULT_PLAN_ID}`

/**
 * `requested` if it is listed, else Plus annual, else the first yearly plan,
 * else the first plan, else `null` for an empty list.
 */
export function preselectPlan(plans: Plan[], requested: string | null): string | null {
  const listed = (id: string | null) => id !== null && plans.some((plan) => plan.id === id)
  if (listed(requested)) return requested
  if (listed(DEFAULT_PLAN_ID)) return DEFAULT_PLAN_ID
  return (plans.find((plan) => plan.interval === 'year') ?? plans[0])?.id ?? null
}
